import * as pbm from '@/grpc-gen/tab_pb';
import ApiTab from '@/model/Tab';

export default class Tab extends ApiTab {
  static fromGrpcModel(o?: pbm.Tab): Tab {
    const tab = new Tab();

    tab.id = Number(o?.id ?? 0);
    tab.order = o?.order ?? 0;
    tab.name = o?.name ?? '';

    return tab;
  }
}
